<template>
  <div id="cup" class="bg-F">
    <Scroller
      :is-finished-data.sync="finished"
      :is-loading-data.sync="loading"
      :is-refresh-data.sync="refresh"
      :no-data-text-data.sync="noDataText"
      @on-infinite="onInfinite"
      @on-refresh="onRefresh"
      ref="my_scroller"
    >
      <div class="pro_list w-100 flex fw-w over-h bg-F5 pt10 pl12 pr12 pb0">
        <div :key="index" class="prolist_item w-50 mb10" v-for="(item, index) of allGoodsList">
          <product-item
            :markPointData="{
              scenepoint: 'itemhot-' + $route.query.itemid + '-' + item.itemid,
              scenedesc: '热销好评'
            }"
            :prolistIndex="index"
            :prolistItem="item"
            :className="'width100'"
            class="bg-F h-100"
          ></product-item>
        </div>
      </div>
    </Scroller>
  </div>
</template>

<script>
import productItem from '../common/productItem'
import Scroller from '../common/Scroller'
import { isWeixin, fenxiang } from '../../assets/common/js/config'
export default {
  name: 'goodsList',
  components: {
    productItem,
    Scroller
  },
  data() {
    return {
      allGoodsList: [],
      refresh: false,
      loading: false,
      finished: false,
      noDataText: '',
      nowPage: 0
    }
  },
  mounted: function () {
    if (isWeixin()) {
      fenxiang({
        path: 'goodsList'
      })
    }
  },
  methods: {
    getData: function () {
      var urlProduct =
        this.$ajax.getItemNewRecommend_URL +
        '?from_type=2&item_base_id=' +
        this.$route.query.itemid +
        '&pageno=' +
        this.nowPage +
        '&pagesize=' +
        this.pagesize
      var that = this
      that.$customRequestAjax(urlProduct).then((res) => {
        if (res.data.code === 200) {
          if (that.nowPage === 1) {
            that.allGoodsList = res.data.itemlist
            that.refresh = false
          } else {
            that.allGoodsList = that.allGoodsList.concat(res.data.itemlist)
          }
          that.loading = false
          if (res.data.itemlist.length < that.pagesize) {
            that.finished = true
          } else {
            that.finished = false
          }
        }
      })
    },
    onRefresh() {
      this.refresh = true
      this.nowPage = 1
      this.allGoodsList = []
      this.getData()
    },
    onInfinite() {
      this.loading = true
      this.finished = false
      this.nowPage++
      this.getData()
    }
  }
}
</script>

<style scoped lang="scss">
#cup {
  flex: 1;
  -webkit-flex: 1;
  -moz-flex: 1;
  -ms-flex: 1;
  -o-flex: 1;
  height: calc(100%);
}

.pro_list {
  .prolist_item:nth-child(2n) {
    padding-left: 0.035rem;
  }
  .prolist_item:nth-child(2n-1) {
    padding-right: 0.035rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/productdetail/goodsList.vue